export interface FilterMenu {
  isMenuOpenOnMobile: boolean
}

export const getInitialFilterMenu = (): FilterMenu => ({
  isMenuOpenOnMobile: false,
})
